const initialState = false;

const settingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'setting/true':
      return true;
    case 'setting/false':
      return false;
    default:
      return state;
  }
};

export default settingReducer;
